import createReactComponent from '../createReactComponent';
export default createReactComponent('circle-letter-d', 'IconCircleLetterD', [
  ['path', { d: 'M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0', key: 'svg-0' }],
  [
    'path',
    { d: 'M10 8v8h2a2 2 0 0 0 2 -2v-4a2 2 0 0 0 -2 -2h-2z', key: 'svg-1' },
  ],
]);
